module.exports = __webpack_public_path__ + "media/images/logo/product-family-a92ad84e103f19eb0ae2989080fbc9b8.jpg";